module.exports = __webpack_public_path__ + "assets/img/sku-img.70392a08.png";